export default function Footer() {
  return (
    <footer
      className="px-6 md:px-12 lg:px-24 py-14 border-t border-gold/10 bg-[#050706]"
      data-testid="site-footer"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div>
          <p className="font-serif text-2xl tracking-[0.45em] text-cream" data-testid="footer-brand">
            ZENIQUE
          </p>
          <p className="mt-4 text-xs font-light tracking-wide text-taupe">
            Residential Design & Furnishing — Sydney
          </p>
        </div>
        <p className="text-[10px] tracking-[0.3em] uppercase text-taupe/60">
          © {new Date().getFullYear()} ZENIQUE. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
